import { getUrl, IMessageBanner } from "lib/types/sanity";
import Link from "next/link";
import styles from "./MessageBanner.module.css";

//#region [Props]
type MessageBannerProps = {
    banner?: IMessageBanner;
};
//#endregion

//#region [Component]
export default function MessageBanner({ banner }: MessageBannerProps) {
    if (!banner?.article) {
        return null;
    }
    const url = getUrl(banner.article);
    if (!url) {
        return null;
    }
    return <div className={styles.messageBanner}>
        <div className={styles.bannerContent}>
            <Link href={url}>{banner.overrideMessage ?? banner.article.title}</Link>
        </div>
    </div>;
}
//#endregion